export default __webpack_public_path__ + "static/media/usdc.ee0410ca.svg";